import {SystemEntity} from '../Entity';
import {RemoteRepository, RemoteRepositoryMock} from '../Repository';

export type GetStatus = () => Promise<SystemEntity[]>;

export const GetStatusUseCase = (
  remote: RemoteRepository = new RemoteRepositoryMock()
): GetStatus => {
  return async (): Promise<SystemEntity[]> => {
    try {
      return await remote.GetStatus();
    } catch (e) {
      throw e;
    }
  };
};
